import {
	InputField,
	ModalContainer,
	Spinner,
	useToast,
} from '@welbe/web-design-system';
import { Button, Stack } from '@welbe/design-system';
import { Container, Subtitle } from './PasswordRecover.styles';
import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import { EmailSuccessfullySent } from './components/EmailSuccessfullySent/EmailSuccessfullySent';
import { FiInfo } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { loggerInfo } from 'utils/infoLog';

export const PasswordRecover = (): JSX.Element => {
	const [isLoading, setLoading] = useState<boolean>(false);
	const [email, setEmail] = useState<string>('');
	const [isModalVisible, setModalVisible] = useState<boolean>(false);
	const navigate = useNavigate();
	const { toast } = useToast();

	const handleToast = (message?: string) => {
		toast.error(message || 'Rellena los campos marcados.');
	};

	const handleSubmit = async (event: React.SyntheticEvent) => {
		event.preventDefault();
		setLoading(true);
		try {
			await Auth.forgotPassword(email);
			setModalVisible(true);
		} catch (error) {
			loggerInfo({
				data: error,
				context: 'login',
				location: 'PasswordRecover',
			});
			handleToast('Hubo un error al intentar realizar esta acción.');
		} finally {
			setLoading(false);
		}
	};

	const handleCloseModal = () => {
		setModalVisible(false);
		const emailToken = window.btoa(email);
		navigate(`/new-password?token=${emailToken}`);
	};

	return (
		<>
			<Container>
				<Subtitle>Escribe tu correo para restablecer tu contraseña</Subtitle>
				<InputField
					id="email"
					placeholder="Correo de usuario"
					type="text"
					value={email}
					onChange={(value) => setEmail(value)}
				/>
				<Stack mt={2}>
					<Button
						id="recovery-button"
						disabled={isLoading}
						onClick={handleSubmit}
					>
						{isLoading ? <Spinner size="24px" color="#fff" /> : 'Confirmar'}
					</Button>
					<Button
						id="go-to-login"
						variant="ghost"
						onClick={() => navigate('/login')}
					>
						Ir a la pantalla de autenticación
					</Button>
				</Stack>
			</Container>

			<ModalContainer
				borderRadius="6px"
				headerIcon={<FiInfo size={36} color="#fff" />}
				visible={isModalVisible}
				width="300px"
				height="300px"
				onClose={handleCloseModal}
			>
				<EmailSuccessfullySent onClose={handleCloseModal} email={email} />
			</ModalContainer>
		</>
	);
};
